import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity8 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_8;
}

export default GravelRoadTileEntity8;
